module.exports = __webpack_public_path__ + "img/fk.aeb2d588.svg";